import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HotMovies from './components/HotMovies';
import CategorySection from './components/CategorySection';
import LatestUpdates from './components/LatestUpdates';
import ArticleRecommend from './components/ArticleRecommend';
import AppDownload from './components/AppDownload';
import FAQSection from './components/FAQSection';

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <HotMovies />
        <CategorySection />
        <LatestUpdates />
        <ArticleRecommend />
        <AppDownload />
        <FAQSection />
      </main>
      <Footer />

      {/* Schema.org Structured Data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: "蚂蚁影视",
            url: "https://www.mantfilm.com",
            description: "蚂蚁影视官网与APP下载入口，提供高清免费在线观看、不缓冲的流畅追剧体验，一站式访问最新热播电影电视剧大全。",
            potentialAction: {
              "@type": "SearchAction",
              target: "https://www.mantfilm.com/search?q={search_term_string}",
              "query-input": "required name=search_term_string"
            },
            publisher: {
              "@type": "Organization",
              name: "蚂蚁影视",
              url: "https://www.mantfilm.com",
              logo: "https://www.mantfilm.com/logo.png"
            }
          }, null, 2)
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "蚂蚁影视是否真的完全免费？",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "是的，蚂蚁影视提供完全免费的在线观影服务。我们通过广告收入来维持平台运营，用户无需支付任何费用即可观看所有内容。"
                }
              },
              {
                "@type": "Question",
                name: "观看需要注册账号吗？",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "不需要。蚂蚁影视支持免注册直接观看。如果你想享受收藏、历史记录等个性化功能，可以选择免费注册账号。"
                }
              },
              {
                "@type": "Question",
                name: "支持哪些设备观看？",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "蚂蚁影视支持在电脑浏览器、手机浏览器、平板电脑上直接观看，同时提供iOS和Android版本APP。"
                }
              },
              {
                "@type": "Question",
                name: "视频画质如何？支持哪些清晰度？",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "蚂蚁影视支持从流畅到4K超清多种画质选择，系统会根据你的网络状况自动选择最佳画质。"
                }
              }
            ]
          }, null, 2)
        }}
      />
    </>
  );
}